import React, { useState } from "react";

const quotes = [
  {
    q: "They are the only people in our property stack with absolutely nothing to sell us. That clarity is worth the fee on its own.",
    a: "Family Office Principal · Singapore",
  },
  {
    q: "We finally have eyes on our London assets without paying a percentage of our rent to someone we've never met.",
    a: "Overseas Landlord · Dubai",
  },
  {
    q: "Dira's spatial blueprint added roughly 18% to our achievable rent before we'd even called a contractor.",
    a: "Boutique Syndicate · Geneva",
  },
];

export default function Testimonials() {
  const [i, setI] = useState(0);
  const current = quotes[i];

  return (
    <section data-testid="testimonials-section" className="py-24 md:py-32 bg-[#EFEBE4] relative">
      <div className="grain" />
      <div className="max-w-5xl mx-auto px-6 md:px-12 relative text-center">
        <span className="text-xs uppercase tracking-[0.28em] text-[#6E5A4E]">In Client Voice</span>

        <div className="mt-10 relative">
          <span
            aria-hidden
            className="font-serif-display text-[160px] md:text-[220px] leading-none text-[#8C735D]/20 absolute -top-10 left-1/2 -translate-x-1/2 select-none"
          >
            “
          </span>
          <blockquote
            data-testid="testimonial-quote"
            className="relative font-serif-display text-2xl md:text-4xl lg:text-[42px] leading-[1.18] text-[#2B211A] font-light tracking-tight max-w-4xl mx-auto"
          >
            {current.q}
          </blockquote>
          <div className="mt-8 text-sm uppercase tracking-[0.28em] text-[#6E5A4E]">
            — {current.a}
          </div>
        </div>

        <div className="mt-12 flex items-center justify-center gap-3" role="tablist">
          {quotes.map((_, idx) => (
            <button
              key={idx}
              onClick={() => setI(idx)}
              role="tab"
              aria-selected={i === idx}
              data-testid={`testimonial-dot-${idx}`}
              className={`h-px transition-all duration-500 ${
                i === idx ? "w-12 bg-[#2B211A]" : "w-6 bg-[#B89A7E]"
              }`}
            />
          ))}
        </div>
      </div>
    </section>
  );
}
